import { BreadTransferSession, BreadTransferConfig, Location } from '../types/bread-transfers.types';

export const mockLocations: Location[] = [
  { id: 'mac-01', code: 'MAC 01', name: 'ANGAMOS', active: true },
  { id: 'mac-02', code: 'MAC 02', name: 'LA ROTONDA', active: true },
  { id: 'mac-03', code: 'MAC 03', name: 'BENAVIDES', active: true },
  { id: 'mac-04', code: 'MAC 04', name: 'SURQUILLO', active: true },
  { id: 'mac-05', code: 'MAC 05', name: 'UPC', active: true },
  { id: 'mac-07', code: 'MAC 07', name: 'LA FONTANA', active: true },
  { id: 'mac-08', code: 'MAC 08', name: 'ULLIMA', active: true },
  { id: 'mac-09', code: 'MAC 09', name: 'MIRAFLORES', active: true },
];

export const mockBreadTransferConfig: BreadTransferConfig = {
  locations: mockLocations,
  defaultParameters: {
    'mac-01': { morningFixedDispatch: 170, afternoonFixedDispatch: 85 },
    'mac-02': { morningFixedDispatch: 170, afternoonFixedDispatch: 85 },
    'mac-03': { morningFixedDispatch: 150, afternoonFixedDispatch: 75 },
    'mac-04': { morningFixedDispatch: 70, afternoonFixedDispatch: 35 },
    'mac-05': { morningFixedDispatch: 70, afternoonFixedDispatch: 35 },
    'mac-07': { morningFixedDispatch: 60, afternoonFixedDispatch: 30 },
    'mac-08': { morningFixedDispatch: 120, afternoonFixedDispatch: 60 },
    'mac-09': { morningFixedDispatch: 40, afternoonFixedDispatch: 20 },
  }
};

export const mockMorningTransfer: BreadTransferSession = {
  id: 'bt-morning-2025-09-12',
  date: '2025-09-12',
  shift: 'morning',
  locations: [
    {
      locationId: 'mac-01',
      locationCode: 'MAC 01',
      locationName: 'ANGAMOS',
      parameterPreviousDay: 80,
      initialStock: 102,
      waste: 22,
      previousDayDispatch: 0,
      fixedDispatch: 170,
      calculatedDispatch: 170
    },
    {
      locationId: 'mac-02',
      locationCode: 'MAC 02',
      locationName: 'LA ROTONDA',
      parameterPreviousDay: 30,
      initialStock: 56,
      waste: 26,
      previousDayDispatch: 0,
      fixedDispatch: 170,
      calculatedDispatch: 170
    },
    {
      locationId: 'mac-03',
      locationCode: 'MAC 03',
      locationName: 'BENAVIDES',
      parameterPreviousDay: 50,
      initialStock: 21,
      waste: 0,
      previousDayDispatch: 29,
      fixedDispatch: 150,
      calculatedDispatch: 179
    },
    {
      locationId: 'mac-04',
      locationCode: 'MAC 04',
      locationName: 'SURQUILLO',
      parameterPreviousDay: 30,
      initialStock: 43,
      waste: 13,
      previousDayDispatch: 0,
      fixedDispatch: 70,
      calculatedDispatch: 70
    },
    {
      locationId: 'mac-05',
      locationCode: 'MAC 05',
      locationName: 'UPC',
      parameterPreviousDay: 30,
      initialStock: 24,
      waste: 0,
      previousDayDispatch: 6,
      fixedDispatch: 70,
      calculatedDispatch: 76
    },
    {
      locationId: 'mac-07',
      locationCode: 'MAC 07',
      locationName: 'LA FONTANA',
      parameterPreviousDay: 30,
      initialStock: 54,
      waste: 24,
      previousDayDispatch: 0,
      fixedDispatch: 60,
      calculatedDispatch: 60
    },
    {
      locationId: 'mac-08',
      locationCode: 'MAC 08',
      locationName: 'ULLIMA',
      parameterPreviousDay: 30,
      initialStock: 43,
      waste: 13,
      previousDayDispatch: 0,
      fixedDispatch: 120,
      calculatedDispatch: 120
    },
    {
      locationId: 'mac-09',
      locationCode: 'MAC 09',
      locationName: 'MIRAFLORES',
      parameterPreviousDay: 20,
      initialStock: 31,
      waste: 11,
      previousDayDispatch: 0,
      fixedDispatch: 40,
      calculatedDispatch: 40
    }
  ],
  totals: {
    parameterPreviousDay: 300,
    initialStock: 374,
    waste: 109,
    previousDayDispatch: 35,
    fixedDispatch: 850,
    calculatedDispatch: 885
  },
  status: 'draft',
  createdAt: '2025-09-12T06:00:00Z',
  updatedAt: '2025-09-12T06:30:00Z'
};

export const mockAfternoonTransfer: BreadTransferSession = {
  id: 'bt-afternoon-2025-09-12',
  date: '2025-09-12',
  shift: 'afternoon',
  locations: mockLocations.map(location => ({
    locationId: location.id,
    locationCode: location.code,
    locationName: location.name,
    parameterPreviousDay: 0,
    initialStock: 0,
    waste: 0,
    previousDayDispatch: 0,
    fixedDispatch: mockBreadTransferConfig.defaultParameters[location.id]?.afternoonFixedDispatch || 0,
    calculatedDispatch: mockBreadTransferConfig.defaultParameters[location.id]?.afternoonFixedDispatch || 0
  })),
  totals: {
    parameterPreviousDay: 0,
    initialStock: 0,
    waste: 0,
    previousDayDispatch: 0,
    fixedDispatch: 425,
    calculatedDispatch: 425
  },
  status: 'draft',
  createdAt: '2025-09-12T14:00:00Z',
  updatedAt: '2025-09-12T14:00:00Z'
};

export const mockBreadTransferSessions: BreadTransferSession[] = [
  mockMorningTransfer,
  mockAfternoonTransfer
];